import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserRole } from '../models/auth.models';
import { APP_ROUTES } from '../constants/routes.constants';

const requireRole = (role: UserRole): ReturnType<CanActivateFn> => {
  const auth   = inject(AuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return router.createUrlTree([APP_ROUTES.auth.login]);
  }

  if (auth.currentUser()?.role === role) {
    return true;
  }

  // Wrong role — send them to their own dashboard
  const destination = auth.isAdmin() ? APP_ROUTES.admin.dashboard : APP_ROUTES.builder.dashboard;
  return router.createUrlTree([destination]);
};

/** Factory - returns a guard that allows only the specified role */
export const roleGuard = (role: UserRole): CanActivateFn => () => requireRole(role);

/** Factory - prevents protected lazy routes from matching for the wrong role */
export const roleMatchGuard = (role: UserRole): CanMatchFn => () => requireRole(role);
